
































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import PemantauanAnestesiSvc from "@/services/PemantauanAnestesiService";
import LaporanOperasiSvc from "@/services/LaporanOperasi";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

@Component({
  components: { CardModalTtd, VCDateTimePicker }
})
export default class PemantauanAnestesiFinalisasi extends Vue {
  @Prop() pemantauan!: any;
  @Prop({ default: false }) readonly!: boolean;

  modalTtd = false;
  signRole = "";
  menarikLapOp = false;
  dirty = false;

  form: any = {
    akhir_operasi_at: "",
    akhir_anestesi_at: "",
    diagnosa_pasca_bedah: "",
    diagnosa_pasca_bedah_icd10: "",
    catatan_durante: "",
  };

  mounted() {
    this.loadData();
  }

  @Watch("pemantauan")
  onPemantauanChanged() {
    if (this.dirty) return;
    this.loadData();
  }

  @Watch("form", { deep: true })
  onFormChanged() {
    this.dirty = true;
  }

  loadData() {
    if (!this.pemantauan) return;
    this.form.akhir_operasi_at = this.pemantauan.akhir_operasi_at
      ? moment(this.pemantauan.akhir_operasi_at).format("YYYY-MM-DDTHH:mm") : "";
    this.form.akhir_anestesi_at = this.pemantauan.akhir_anestesi_at
      ? moment(this.pemantauan.akhir_anestesi_at).format("YYYY-MM-DDTHH:mm") : "";
    this.form.diagnosa_pasca_bedah = this.pemantauan.diagnosa_pasca_bedah || "";
    this.form.diagnosa_pasca_bedah_icd10 = this.pemantauan.diagnosa_pasca_bedah_icd10 || "";
    this.form.catatan_durante = this.pemantauan.catatan_durante || "";
    this.$nextTick(() => {
      this.dirty = false;
    });
  }

  get waktuDate() {
    const ke = (v: string) => (v ? moment(v).toDate() : null);
    return {
      akhir_operasi_at: ke(this.form.akhir_operasi_at),
      akhir_anestesi_at: ke(this.form.akhir_anestesi_at)
    };
  }

  setWaktu(field: string, val: Date | null) {
    if (this.readonly || this.pemantauan?.is_locked) return;
    this.$set(this.form, field, val ? moment(val).format("YYYY-MM-DDTHH:mm") : "");
  }

  isiSekarang(field: string) {
    if (this.readonly || this.pemantauan?.is_locked) return;
    this.$set(this.form, field, moment().format("YYYY-MM-DDTHH:mm"));
  }

  formatDateTime(dt: string) {
    return dt ? moment(dt).format("DD-MM-YYYY HH:mm") : "-";
  }

  async ambilDariLaporanOperasi() {
    if (this.readonly || this.pemantauan?.is_locked || this.menarikLapOp) return;
    this.menarikLapOp = true;
    try {
      const resp = await LaporanOperasiSvc.getByRegister(
        this.pemantauan.register_id
      );
      const list: any[] = (resp?.data as any) || [];
      if (!list.length) {
        appModule.sendErrorAlert("Belum ada Laporan Operasi pada kunjungan ini");
        return;
      }
      const dx = list[list.length - 1].diag_pasca || "";
      if (!dx) {
        appModule.sendErrorAlert(
          "Laporan Operasi belum mengisi diagnosa pasca bedah"
        );
        return;
      }
      this.form.diagnosa_pasca_bedah = dx;
      appModule.NoticeDelay("Diagnosa diambil dari Laporan Operasi");
    } catch {
      // handled by service
    } finally {
      this.menarikLapOp = false;
    }
  }

  // ── Kontrak langkah (dipanggil stepper lewat $refs) ─────────────────
  validateStep(): boolean {
    return true;
  }

  collectPayload(): any {
    return {
      ...this.form,
      akhir_operasi_at: this.form.akhir_operasi_at || null,
      akhir_anestesi_at: this.form.akhir_anestesi_at || null,
    };
  }

  isDirty(): boolean {
    return this.dirty;
  }

  markSaved() {
    this.dirty = false;
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    try {
      const resp = await PemantauanAnestesiSvc.sign(this.pemantauan.id, {
        role: this.signRole,
        password: password,
      });
      if (resp?.data?.status == "1") {
        this.modalTtd = false;
        appModule.NoticeDelay("Berhasil Tanda Tangan...");
        this.$emit("refresh");
      } else {
        appModule.addMsgTtd(resp?.data?.message || "Gagal tanda tangan");
        this.modalTtd = true;
      }
    } catch (err) {
      const msg = err?.response?.data?.message || "Gagal tanda tangan";
      appModule.addMsgTtd(msg);
      this.modalTtd = true;
    }
  }

  cetakPdf() {
    PemantauanAnestesiSvc.printPdf(this.pemantauan.id);
  }
}
